module.exports = __webpack_public_path__ + "img/ketqua.85b3e944.png";